import SvgIcon from '@mui/material/SvgIcon';

import type { SvgIconProps } from '@mui/material/SvgIcon';

const GXIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        id='Layer_1'
        viewBox='0 0 566.93 566.93'
        x={0}
        xmlns='http://www.w3.org/2000/svg'
        xmlSpace='preserve'
        y={0}
        {...props}
      >
        <style>{'.st1{fill:#e65300}'}</style>
        <switch>
          <g>
            <path
              d='M548.49 253.59v29.88c0 62.32-21.76 119.58-57.9 164.88l-17.27 19.64c-1.75 1.8-3.53 3.57-5.33 5.33l-19.66 17.29c-45.3 36.13-102.55 57.89-164.87 57.89-61.66 0-118.48-21.17-163.55-56.62l-16.06-13.69c-4.76-4.39-9.34-8.94-13.75-13.66L77.37 449.9c-36.84-45.53-58.92-103.44-58.92-166.43 0-146.13 118.88-265.02 265.02-265.02 70.8 0 137.35 27.56 187.4 77.61l21.04 21.04-43.42 43.74c-38.73-52.36-99.82-83.42-165.23-83.42-113.32 0-205.51 92.18-205.51 205.5 0 68.18 33.41 128.68 84.68 166.09l-.08.08c1.26.92 2.61 1.73 3.89 2.63 1.49 1.04 2.99 2.05 4.51 3.05 32.39 21.38 71.08 33.95 112.7 33.95 26.73 0 52.2-5.29 75.63-14.64.66-.26 1.32-.49 1.98-.76 2.69-1.11 5.33-2.3 7.96-3.51 2.17-.99 4.32-2.02 6.46-3.09 1.88-.95 3.75-1.9 5.59-2.91 3.17-1.71 6.27-3.53 9.35-5.4.96-.59 1.95-1.15 2.9-1.75 20.92-13.27 39.43-30.45 54.65-50.93l.02.02c.16-.22.31-.45.47-.67 1.98-2.69 3.9-5.44 5.77-8.24.61-.92 1.22-1.84 1.81-2.77.91-1.41 1.87-2.76 2.75-4.19l-.12-.07c14.04-22.95 23.83-48.74 27.89-76.45h-53.01l-28.61-29.34 28.61-30.42h114.94zm-222.24 30.4 98.2-98.93c-11.62-16.73-25.88-31.02-42.04-42.45L284 241.74l-99.32-99.32a173.246 173.246 0 0 0-42.21 42.3l99.43 99.43-98.08 98.8c11.71 16.28 26.1 30.51 42.66 41.85l97.67-98.39 97.49 97.49c16.2-11.34 30.56-25.5 42.28-42.23l-97.67-97.68z'
              style={{
                fill: '#fff'
              }}
            />
          </g>
        </switch>
      </svg>
    </SvgIcon>
  );
};
export default GXIcon;
